import React, { useMemo } from "react";
import { View } from "@react-pdf/renderer";
import { withNamespaces } from "react-i18next";

import styles from "../../Styles";
import {
    buildGroupStructureTableRows,
    resolveGroupStructureGraph,
} from "../../helpers/groupStructureGraph";
import {
    buildMonitoringExportRows,
    buildScreeningExportRows,
} from "../../helpers/complianceExport";
import GroupStructureGraph from "../GroupStructureGraph";
import ComplianceTable from "../ComplianceTable";
import { KeyValueTable, SectionTitle } from "../shared";
import { TOC_ANCHORS } from "../../helpers/tableOfContents";

const StructureAndComplianceSections = ({ t, supplierData = {} }) => {
    const graphData = resolveGroupStructureGraph(supplierData);
    const groupRows = buildGroupStructureTableRows(graphData);

    const monitoringRows = useMemo(
        () => buildMonitoringExportRows(supplierData?.complianceMonitoring, { t }),
        [supplierData?.complianceMonitoring, t]
    );

    const screeningRows = useMemo(
        () => buildScreeningExportRows(supplierData?.complianceScreening, { t }),
        [supplierData?.complianceScreening, t]
    );

    return (
        <View style={styles.wordSectionContent}>
            <SectionTitle title="Group Structure Graph" number="3" anchorId={TOC_ANCHORS.SECTION_3} />
            <GroupStructureGraph graphData={graphData} />
            <KeyValueTable rows={groupRows} titleColumnLabel="Entity" detailsColumnLabel="Role / Ownership" />

            <SectionTitle title="Compliance Monitoring" number="4" anchorId={TOC_ANCHORS.SECTION_4} />
            <ComplianceTable rows={monitoringRows} />

            <SectionTitle title="Compliance Screening" number="5" anchorId={TOC_ANCHORS.SECTION_5} />
            <ComplianceTable rows={screeningRows} />
        </View>
    );
};

export default withNamespaces()(StructureAndComplianceSections);
